export const TUTOR_AVATAR_DEFAULT_EXPERIMENT_KEY = "tutor_avatar_default_view_v1";

export type TutorAvatarDefaultView = "compact" | "large" | "header";

export type TutorAvatarDefaultPostHogClient = {
  getFeatureFlagResult: (
    key: string,
    options?: { fresh?: boolean; send_event?: boolean }
  ) => { variant?: string } | undefined;
};

export type TutorAvatarDefaultAssignment = {
  view: TutorAvatarDefaultView;
  source: "posthog" | "fallback";
};

export function parseTutorAvatarDefaultView(value: unknown): TutorAvatarDefaultView | null {
  return value === "compact" || value === "large" || value === "header" ? value : null;
}

/** Read once when an eligible session renders. A late flag never moves its avatar. */
export function resolveTutorAvatarDefaultView(
  posthog: TutorAvatarDefaultPostHogClient | null | undefined
): TutorAvatarDefaultAssignment {
  try {
    const result = posthog?.getFeatureFlagResult(TUTOR_AVATAR_DEFAULT_EXPERIMENT_KEY, {
      fresh: true,
      send_event: false,
    });
    const view = parseTutorAvatarDefaultView(result?.variant);
    if (view) return { view, source: "posthog" };
  } catch {
    // Analytics must not hold up speaking or make the avatar unavailable.
  }
  return { view: "compact", source: "fallback" };
}

/** Expose only a real assignment matching the view rendered in the session. */
export function exposeTutorAvatarDefaultView(
  posthog: TutorAvatarDefaultPostHogClient,
  view: TutorAvatarDefaultView
): boolean {
  try {
    const result = posthog.getFeatureFlagResult(TUTOR_AVATAR_DEFAULT_EXPERIMENT_KEY, {
      fresh: true,
      send_event: false,
    });
    if (parseTutorAvatarDefaultView(result?.variant) !== view) return false;
    posthog.getFeatureFlagResult(TUTOR_AVATAR_DEFAULT_EXPERIMENT_KEY, {
      fresh: true,
      send_event: true,
    });
    return true;
  } catch {
    return false;
  }
}
